var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardExerciseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#AEECCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5561 16.9821C31.7002 16.9821 32.6277 16.0433 32.6277 14.8852C32.6277 13.7271 31.7002 12.7883 30.5561 12.7883C29.4119 12.7883 28.4844 13.7271 28.4844 14.8852C28.4844 16.0433 29.4119 16.9821 30.5561 16.9821Z",
    fill: "#284744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.241 15.3945L33.253 20.0763L34.326 18.3063C34.6417 17.7853 35.3062 17.6133 35.8284 17.9094L35.883 17.9424C36.4092 18.2752 36.5718 18.9752 36.2474 19.5105L34.8842 21.7596C34.8387 21.8347 34.7859 21.9026 34.7274 21.9628C34.7027 22.0435 34.6688 22.1228 34.6253 22.1991C34.3133 22.7462 33.6222 22.9336 33.0817 22.6178L30.9155 21.352L28.9485 24.5551L28.9723 24.6214L30.1594 25.2401C30.5731 25.4788 30.78 25.9479 30.78 26.6475C30.78 27.256 30.0858 27.8816 28.6974 28.5243L25.8696 30.2644C25.8433 30.322 25.8132 30.3785 25.7791 30.4337L24.0825 33.1819C23.6415 33.8962 22.712 34.1134 22.0063 33.667C21.3006 33.2207 21.086 32.2799 21.527 31.5656L23.2236 28.8174C23.3146 28.67 23.4264 28.5438 23.5528 28.4402L24.8976 26.2951L24.5962 26.0957C23.5208 25.3834 23.3916 24.3474 24.2087 22.9879L24.2477 22.924L26.6409 18.854L25.0634 17.9322L23.4037 20.6208C23.073 21.1565 22.3759 21.3194 21.8466 20.9847C21.3173 20.65 21.1564 19.9443 21.4871 19.4086L23.583 16.0138C23.6004 15.9855 23.6189 15.9583 23.6383 15.9321C23.6555 15.8918 23.6752 15.8521 23.6974 15.8132C24.0095 15.2661 24.7006 15.0787 25.241 15.3945Z",
    fill: "#284744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 22.7254C12.001 22.2566 12.3811 21.8765 12.8499 21.8765H20.6527C21.1216 21.8765 21.5017 22.2566 21.5017 22.7254C21.5017 23.1943 21.1216 23.5744 20.6527 23.5744H12.8499C12.3811 23.5744 12.001 23.1943 12.001 22.7254Z",
    fill: "#6C9888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5923 26.9907C15.5687 26.5238 15.9408 26.1323 16.4083 26.1323H20.0633C20.4984 26.1323 20.8572 26.4734 20.8793 26.908C20.9029 27.3749 20.5307 27.7664 20.0633 27.7664H16.4083C15.9731 27.7664 15.6143 27.4253 15.5923 26.9907Z",
    fill: "#6C9888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardExerciseIcon);
export default __webpack_public_path__ + "static/media/card-exercise-icon.8b5107fe924229d273e153ec841db7cd.svg";
export { ForwardRef as ReactComponent };